import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-view-landing-page-video',
  templateUrl: './view-landing-page-video.component.html',
  styleUrls: ['./view-landing-page-video.component.scss'],
})
export class ViewLandingPageVideoComponent implements OnInit {
  videos: any[] = [];
  
  constructor( @Inject(MAT_DIALOG_DATA) public getData: any, private sanitizer: DomSanitizer ){
    console.log(getData.showData);
    let datapatch=getData.showData?.filteredData?getData.showData?.filteredData:getData.showData;
    // Preprocess video data
    this.videos = datapatch.map((video: any, index: number) => {
      const sanitizedUrl = this.sanitizeUrl(video.url); // not video.sanitizedUrl from API
      return {
        ...video,
        index,
        isInstagram: this.isInstagramUrl(video.url),
        isFile: this.isVideoFile(video.url),
        sanitizedUrl: sanitizedUrl  // SafeResourceUrl created at runtime
      };
    });
    
  }
  
  sanitizeUrl(url: string): SafeResourceUrl | null {
    if (!url) return null;
    
    let embedUrl = url;
    
    // Case 1: Normal YouTube watch link
    if (url.includes('youtube.com/watch?v=')) {
      const videoId = url.split('v=')[1].split('&')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0`;
    }
    
    // Case 2: Short youtu.be link
    else if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1].split('?')[0];
      console.log(videoId);
      
      embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0`;
    }
    
    // Case 3: Vimeo
    else if (url.includes('vimeo.com')) {
      const videoId = url.split('/').pop();
      embedUrl = `https://player.vimeo.com/video/${videoId}`;
    }
    // Case 4b: Dailymotion short link (dai.ly)
    else if (url.includes('dai.ly/')) {
      const videoId = url.split('dai.ly/')[1];
      embedUrl = `https://www.dailymotion.com/embed/video/${videoId}`;
    }
    
    // Case 4: Dailymotion
    else if (url.includes('dailymotion.com/video')) {
      const videoId = url.split('/video/')[1];
      embedUrl = `https://www.dailymotion.com/embed/video/${videoId}`;
    }
    
    // Case 5: Google Drive
    else if (url.includes('drive.google.com/file/d/')) {
      const fileId = url.split('/d/')[1].split('/')[0];
      embedUrl = `https://drive.google.com/file/d/${fileId}/preview`;
    }
    
    // Case 6: Direct video file
    else if (url.endsWith('.mp4') || url.endsWith('.webm') || url.endsWith('.ogg')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    
    // Case 7: Unsupported (Instagram, Flipkart, etc.)
    else if (url.includes('instagram.com') || url.includes('flipkart.com')) {
      return null;
    }
    
    // ✅ Always return SafeResourceUrl
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }
  
  ngOnInit(): void {}
  
  openYoutube(url: string): void {
    window.open(url, '_blank'); // open YouTube in new tab
  }
  
  isFlipkartUrl(url: string): boolean {
    if (!url) return false;
    return url.includes('flipkart.com');
  }
  
  isInstagramUrl(url: string): boolean {
    return url.includes('instagram.com');
  }
  
  isVideoFile(url: string): boolean {
    return url.endsWith('.mp4') || url.endsWith('.webm') || url.endsWith('.ogg');
  }
  
  trackByFn(index: number, video: any): any {
    return video.id || index;
  }
}
